import TR from 'utils/TR';
import useNavAction from 'hooks/actions/useNavAction';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';
import React from 'react';
import HBox from 'components/common/HBox';

export default function OverviewTabs(props) {
  const {
    children,
    data,
    ...rest
  } = props;

  const {
    triggered: triggeredOverviewAGP,
    onTrigger: onTriggerOverviewAGP,
  } = useNavAction({ name: 'OverviewAGP' }, props);

  const {
    triggered: triggeredOverviewScatter,
    onTrigger: onTriggerOverviewScatter,
  } = useNavAction({ name: 'OverviewScatter', props: { data } }, props);

  React.useEffect(() => {
    if(!triggeredOverviewScatter) return;
    onTriggerOverviewScatter()();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <HBox {...ex('OverviewTabs', rest)}>
      <HBox>
        <FocusableButton
          {...ex(['OverviewButton', { triggered: triggeredOverviewAGP }], {
            disabled: triggeredOverviewAGP,
            onClick: onTriggerOverviewAGP(),
          })}
        >
          {T('AGP')}
        </FocusableButton>
        <FocusableButton
          {...ex(['OverviewButton', { triggered: triggeredOverviewScatter }], {
            disabled: triggeredOverviewScatter,
            onClick: onTriggerOverviewScatter(),
          })}
        >
          {T('이상혈당')}
        </FocusableButton>
      </HBox>
    </HBox>
  );
}
